import { RootState } from 'initializers/types';

import { CheckoutState } from 'features/productGrowth/types';

export const getCheckout = (state: RootState) =>
  state.get('checkout') as CheckoutState;
